module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_15.c9802cc8ea81df9913fd265537bdbd26.png";